// extracted by mini-css-extract-plugin
export default {"main-block":"xb7Nq","slider-container":"PuiuT"};